import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getSubFormListStart, removeSubFormByIdStart, resetStateModule, getSubFormModuleCreatedRecordsStart, getSubFormModuleGraphicalStatusStart } from "../../../Store/Slices/subFormSlice";
import { useDispatch, useSelector } from "react-redux";
import { Utils } from "../../../Utils";
import ImportModal from "../../../Components/ModalPopup/FormModules/ImportModal";
import Loader from "../../../Components/Loader";
import ConfirmationModal from "../../../Components/ModalPopup/ConfirmationModal";
import { Helpers } from "../../../Helpers";
import { HeaderImages } from "../../../Assets";
import ManageColumn from "../../../Components/ModalPopup/FormModules/ManageColumn";
import Charts from "../../../Components/Charts";
import { AgGridReact } from '@ag-grid-community/react';
import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-quartz.css';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { ModuleRegistry } from '@ag-grid-community/core';
import Pagination from "../../../Components/formModules/Pagination";
import PreviewModal from "../../../Components/ModalPopup/FormModules/PreviewModal";
import { createTableColumnSubFormModuleStart, updateTableColumnSubFormModuleStart, destroyModuleLog } from "../../../Store/Slices/subFormSlice";
import { getItem } from "../../../Services/localService";
import PermissionDeniedModal from "../../../Components/PermissionDeniedModal";
import { Collapse } from 'react-bootstrap';
ModuleRegistry.registerModules([ClientSideRowModelModule]);

const SubModule = () => {
    const basicPermissionData = getItem('modulePermission')?.basic;
    let formsubmodules = useSelector((state) => state?.subForm);
    let { id } = useParams();
    let navigate = useNavigate();
    let dispatch = useDispatch();
    let [dynamicTableHeader, setDynamicTableHeader] = useState([]);
    let [subFormlayoutList, setSubFormlayoutList] = useState([]);
    let [openImportModal, setOpenImportModal] = useState(false);
    let [removeModalData, setRemoveModalData] = useState(null);
    let [showManageColumn, setShowManageColumn] = useState(null);
    let [columnDefs, setColumnDefs] = useState([]);
    let gridRef = useRef();
    let [showCharts, setShowCharts] = useState(false);
    let [currentPage, setCurrentPage] = useState(1);
    let [pageSize, setPageSize] = useState(10);
    let [selectedDays, setSelectedDays] = useState("Week");
    let [showFilter, setShowFilter] = useState(false);
    let [showPreviewModalIndex, setShowPreviewModalIndex] = useState(null);
    let [permissionDenied, setPermissionDenied] = useState(false);
    let [open, setOpen] = useState(localStorage.getItem("isChartOpen") === "true");
    const [isActive, setIsActive] = useState(true);
   
    useEffect(() => {
        if(!formsubmodules?.graphicalStatus && !formsubmodules?.isLoading) {
            setOpen(false);
        }
    }, [formsubmodules?.graphicalStatus]);

    useEffect(() => {
        if (formsubmodules?.modules?.name?.replaceAll(' ', '').toLowerCase() == 'articlemaster') {
            setShowCharts(true);
        } else {
            setShowCharts(false);
        }
        if (formsubmodules?.formsubmodules?.length > 0 && id) {
            let processedData = formsubmodules.formsubmodules.map((item) => {
                return {
                    ...item.data.reduce((acc, curr) => ({
                        ...acc,
                        ...curr.section_data
                    }), {}),
                    User_Name: item?.userId?.firstName ? (item?.userId?.firstName + ' ' + item?.userId?.lastName) : '_',
                    SAP_Status: (item.sapResponse?.sapStatus || '_'),
                    SAP_Message: (item.sapResponse?.sapMsg || '_'),
                    ...(formsubmodules?.workflowRules ? { Status: item.status || '_' } : {})
                }
            });
            setSubFormlayoutList(processedData);
        } else {
            setSubFormlayoutList([]);
        }
        if (formsubmodules?.tableColumns?.data?.length > 0) {
            let tableColumns = formsubmodules.tableColumns.data || [];
            let staticColumns = [
                { label: "User Name", show: true, static: true },
                { label: "SAP Status", show: true, static: true },
                { label: "SAP Message", show: true, static: true }
            ];
            let staticStatusColumn = { label: "Status", show: true, static: true };
            let doesLabelExist = (label) => tableColumns.some(col => col.label === label);
            if (formsubmodules?.workflowRules && !doesLabelExist(staticStatusColumn.label)) {
                tableColumns = [staticStatusColumn, ...tableColumns];
            }
            if (formsubmodules?.sapStatus) {
                let filteredStaticColumns = staticColumns.filter(col => !doesLabelExist(col.label));
                tableColumns = [...filteredStaticColumns, ...tableColumns];
            }
            setDynamicTableHeader(tableColumns);
            setColumnData(tableColumns);

        } else {
            if (formsubmodules?.modules?._id && id) {
                let moduleStoreData = formsubmodules.modules.fields;
                if (moduleStoreData) {
                    let fieldLabels = [
                        ...(formsubmodules?.sapStatus
                            ? [
                                { label: "User Name", show: true, static: true },
                                { label: "SAP Status", show: true, static: true },
                                { label: "SAP Message", show: true, static: true }
                            ]
                            : []
                        ),
                        ...(formsubmodules?.workflowRules ? [{ label: "Status", show: true, static: true }] : [])
                    ];
                    moduleStoreData?.sections.forEach(section => {
                        Object.entries(section?.dropped_list || {}).forEach(([key, value]) => {
                            value?.forEach(item => {
                                let label = item?.extra_fields?.field_label;
                                if (label && (['text', 'email', 'tel', 'number', 'select'].includes(item?.input_type) ||
                                    (item?.input_type === "user" && item?.extra_fields?.user_type === "single_user"))) {
                                    fieldLabels.push({ label, show: true, static: false });
                                }
                            });
                        });
                    });
                    setDynamicTableHeader(fieldLabels);
                    setColumnData(fieldLabels);
                }
            } else {
                setDynamicTableHeader([]);
            }
        }
    }, [formsubmodules?.modules, formsubmodules?.tableColumns, formsubmodules?.formsubmodules]);

    useEffect(() => {
        if (formsubmodules?.modules?._id?.length > 0 && formsubmodules?.modules?.name === "Article Master") {
            dispatch(getSubFormModuleCreatedRecordsStart(id));
            dispatch(getSubFormModuleGraphicalStatusStart({
                moduleId: id,
                status: selectedDays
            }));
        }
    }, [formsubmodules?.modules?._id]);

    const setColumnData = (data) => {
        let columns = data?.filter(x => x.show)?.map((x) => ({
            headerName: x.label,
            field: Helpers.replaceData(x.label),
            cellRenderer: (params) => {
                let value = params?.value;
                return (typeof value === "object" ? value?.name : value) || '_';
            }
        })) || [];

        columns.unshift({
            headerCheckboxSelection: true,
            checkboxSelection: true,
            filter: false,
            sortable: false,
            width: 50
        })

        columns.unshift({
            width: 50,
            resizable: false,
            suppressMovable: true,
            filter: false,
            sortable: false,
            cellRenderer: (params) => {
                let rowIndex = params.node.rowIndex;
                let dropdownId = `dropdownMenu-${rowIndex}`;
                let rowId = formsubmodules?.formsubmodules?.[rowIndex]?._id;

                return (
                    <div className="nested-dropdown dropdown">
                        <i className="fa fa-ellipsis-h cursor-pointer"
                            id={dropdownId}
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        ></i>
                        <ul className="dropdown-menu end-unset p-0" aria-labelledby={dropdownId}>
                            <li>
                                <a className="dropdown-item"
                                    onClick={() => setShowPreviewModalIndex(rowIndex)}>
                                    Display
                                </a>
                            </li>
                            <li>
                                <a className="dropdown-item"
                                    onClick={() => {
                                        dispatch(resetStateModule());
                                        navigate(Utils.getNavigationUrl(`form-module/sub-form/update/${id}/${formsubmodules?.formsubmodules?.[rowIndex]?._id}`));
                                    }}
                                >
                                    Edit
                                </a>
                            </li>
                            <li>
                                <a className="dropdown-item">Send Email</a>
                            </li>

                        </ul>
                        <i className="fas fa-trash" style={{ 
                                    color: 'rgb(220, 53, 69)', 
                                    position: 'absolute', 
                                    bottom: '12px', 
                                    left: '25px' 
                                  }}
                                  onClick={() =>
                                    !basicPermissionData?.some(
                                        (x) => x?.id === id && x.activities.delete === true
                                    )
                                        ? setPermissionDenied(true)
                                        : rowId
                                        ? setRemoveModalData({
                                            subModuleId: rowId,
                                            payload : {
                                                _id: rowId,
                                                moduleId: formsubmodules.modules._id
                                            }

                                          
                                            
                                        })
                                : console.error('rowId is undefined')
                            }
                            
                                  />
                    </div>

                );
            },
            cellStyle: { "overflow": 'visible' }
        });


        setColumnDefs(columns);
    }

    useEffect(() => {
        setTimeout(() => {
            if (formsubmodules?.reload && id?.length > 0) {
                dispatch(getSubFormListStart({ page: currentPage, count: pageSize, id, isActive }));
            }
        }, 1000);
    }, [formsubmodules?.reload, isActive]);

    const removeData = (subModuleId) => {
        dispatch(removeSubFormByIdStart(subModuleId));
    }

    const clickExportData = () => {
        let fileName = Helpers.replaceData(formsubmodules?.modules?.name);
        Utils.exportData([dynamicTableHeader?.map(x => x?.label)], fileName);
    }

    let onFilterTextBoxChanged = (event) => {
        gridRef.current.api.setGridOption(
            "quickFilterText",
            event.target.value,
        );
    }

    useEffect(() => {
        if (id?.length > 0) {
            dispatch(getSubFormListStart({ page: currentPage, count: pageSize, id, isActive }));
        }
    }, [id, currentPage, pageSize, isActive]);

    let handlePrevPage = () => {
        setCurrentPage((prev) => Math.max(prev - 1, 1));
    };

    let handleNextPage = () => {
        let totalPages = Math.ceil(formsubmodules?.totalCount / pageSize);
        setCurrentPage((prev) => Math.min(prev + 1, totalPages));
    };

    let handlePageSizeChange = (size) => {
        setPageSize(size);
    };

    let changeDay = (val) => {
        if (val === selectedDays) return;
        dispatch(getSubFormModuleGraphicalStatusStart({
            moduleId: id,
            status: val
        }));
        setSelectedDays(val);
    }
    return (
        <>
            <Loader isVisible={formsubmodules?.isLoading} />
            <div className="container-fluid">
                <div className="row">
                    <Collapse in={open}>
                        <div className="col-12  mt-3">
                            <div className="card text-end">
                                <div className="card-body p-0" id="collapseExample">
                                    <div className="row">
                                        {
                                            (showCharts && formsubmodules?.graphicalStatus) && <>
                                                <div className="col-md-4">
                                                    <div className="card rounded-4 shadow-sm">
                                                        <div className="card-body p-0">
                                                            <div className="card-title h6 fw-semibold d-flex align-items-center">
                                                                <span>Artical Master Status</span>
                                                                <div className="ms-auto">
                                                                    <div className="btn-group btn-group-sm">
                                                                        <button type="button" className="btn flat-btn dropdown-toggle rounded lh-sm" data-bs-toggle="dropdown" aria-expanded="false">
                                                                            <span>{selectedDays}</span> <i className="fa-solid fa-ellipsis"></i>
                                                                        </button>
                                                                        <ul className="dropdown-menu min-w-auto">
                                                                            <li><a className="dropdown-item cursor-pointer" onClick={() => changeDay("Day")}>Day</a></li>
                                                                            <li><a className="dropdown-item cursor-pointer" onClick={() => changeDay("Week")}>Week</a></li>
                                                                            <li><a className="dropdown-item cursor-pointer" onClick={() => changeDay("Month")}>Month</a></li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="article-donut-chart">
                                                                <Charts type='donut' series={[(formsubmodules?.graphicalStatus?.InApprovalCount || 0), (formsubmodules?.graphicalStatus?.SuccessCount || 0), (formsubmodules?.graphicalStatus?.FailCount || 0)]}
                                                                    options={{
                                                                        chart: {
                                                                            type: 'donut',
                                                                            height: '100%'
                                                                        },
                                                                        dataLabels: {
                                                                            enabled: false
                                                                        },

                                                                        responsive: [{
                                                                            breakpoint: 768,
                                                                            options: {
                                                                                chart: {
                                                                                    width: 300,
                                                                                    height: 200
                                                                                },
                                                                                legend: {
                                                                                    position: 'bottom',
                                                                                }
                                                                            }
                                                                        }],
                                                                        legend: {
                                                                            markers: {
                                                                                fillColors: ["#A4B0BE", "#29409d", "#29409d80"]
                                                                            }
                                                                        },
                                                                        labels: ["In Approval", "Success", "Error"],
                                                                        fill: {
                                                                            colors: ["#A4B0BE", "#29409d", "#29409d80"]
                                                                        }
                                                                    }} />
                                                                <div id="html-dist"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="card rounded-4 shadow-sm h-100">
                                                        <div className="card-body p-0">
                                                            <div className="card-title h6 fw-semibold">Created Records</div>
                                                            <div className="progress-chart h-75 d-flex flex-column justify-content-around">
                                                                <div className="daily">
                                                                    <div className="d-flex justify-content-between">
                                                                        <span className="label">Daily</span>
                                                                        <span className="count">{formsubmodules?.createdRecords?.todayCount}</span>
                                                                    </div>
                                                                    <div className="progress" style={{ height: "6px" }}>
                                                                        <div className="progress-bar rounded-2" role="progressbar" aria-label="Example 1px high"
                                                                            style={{ width: "75%", backgroundColor: "#29409d" }}
                                                                            aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                                                                    </div>
                                                                </div>
                                                                <div className="weekly">
                                                                    <div className="d-flex justify-content-between">
                                                                        <span className="label">Weekly</span>
                                                                        <span className="count">{formsubmodules?.createdRecords?.oneWeekCount}</span>
                                                                    </div>
                                                                    <div className="progress" style={{ height: "6px" }}>
                                                                        <div className="progress-bar rounded-2" role="progressbar" aria-label="Example 1px high"
                                                                            style={{ width: "50%", backgroundColor: "#29409d" }}
                                                                            aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                                                                    </div>
                                                                </div>
                                                                <div className="monthly">
                                                                    <div className="d-flex justify-content-between">
                                                                        <span className="label">Monthly</span>
                                                                        <span className="count">{formsubmodules?.createdRecords?.oneMonthCount}</span>
                                                                    </div>
                                                                    <div className="progress" style={{ height: "6px" }}>
                                                                        <div className="progress-bar rounded-2" role="progressbar" aria-label="Example 1px high"
                                                                            style={{ width: "62%", backgroundColor: "#29409d" }}
                                                                            aria-valuenow="62" aria-valuemin="0" aria-valuemax="100"></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="card rounded-4 shadow-sm h-100">
                                                        <div className="card-body p-0">
                                                            <div className="card-title h6 fw-semibold">Material Type</div>
                                                            <div className="progress-chart h-75 d-flex flex-column justify-content-around">
                                                                <div className="daily">
                                                                    <div className="d-flex justify-content-between">
                                                                        <span className="label">SW</span>
                                                                        <span className="count">456</span>
                                                                    </div>
                                                                    <div className="progress" style={{ height: "6px" }}>
                                                                        <div className="progress-bar rounded-2" role="progressbar" aria-label="Example 1px high"
                                                                            style={{ width: "75%", backgroundColor: "#29409d" }}
                                                                            aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                                                                    </div>
                                                                </div>
                                                                <div className="weekly">
                                                                    <div className="d-flex justify-content-between">
                                                                        <span className="label">RF</span>
                                                                        <span className="count">456448</span>
                                                                    </div>
                                                                    <div className="progress" style={{ height: "6px" }}>
                                                                        <div className="progress-bar rounded-2" role="progressbar" aria-label="Example 1px high"
                                                                            style={{ width: "50%", backgroundColor: "#29409d" }}
                                                                            aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                                                                    </div>
                                                                </div>
                                                                <div className="monthly">
                                                                    <div className="d-flex justify-content-between">
                                                                        <span className="label">RAW</span>
                                                                        <span className="count">200000</span>
                                                                    </div>
                                                                    <div className="progress" style={{ height: "6px" }}>
                                                                        <div className="progress-bar rounded-2" role="progressbar" aria-label="Example 1px high"
                                                                            style={{ width: "62%", backgroundColor: "#29409d" }}
                                                                            aria-valuenow="62" aria-valuemin="0" aria-valuemax="100"></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Collapse>
                    <div className="col-md-12 pt-3">
                        <div className="card rounded-4 border-0 shadow-sm sub-form-module">
                            <div className="card-body p-0">
                                <div className="col-md-12 setup-actions d-flex pb-2 pt-0">
                                    <div className="me-3">
                                        <button className="btn btn-primary rounded-pill btn-digy-dark" onClick={() => navigate(-1)}>
                                            <i className="fa fa-arrow-left me-2"></i> Back
                                        </button>
                                    </div>
                                    <div className="left d-flex align-items-start">
                                        <div className="search-box border rounded-pill">
                                            <button className="searchbutton bg-white" type="button"><i className="fa-solid fa-magnifying-glass"></i></button>
                                            <input type="search" placeholder="Search" className="searchfield bg-white" onInput={onFilterTextBoxChanged} />
                                        </div>
                                    </div>
                                    <div className="ms-3">
                                        <div className="d-flex align-items-center">
                                           <span className="me-2">All</span>
                                           <div className="form-check form-switch">
                                           <input className="form-check-input" type="checkbox" checked={!isActive} onChange={(e) => setIsActive(!isActive)} />
                                         </div>
                                      <span className="me-2">Deleted Records</span>
                                    </div>
                                    </div>
                                    <div className="ms-auto">
                                        <div className="btn-group">
                                            <button type="button" className="btn btn-primary me-2px rounded-start btn-digy-dark" onClick={() => navigate(Utils.getNavigationUrl(`form-module/sub-form/create/${id}`))}
                                                disabled={!basicPermissionData?.some(x => x?.id === id && x.activities.create === true)}>
                                                <i className="fa fa-plus me-2"></i> Create {formsubmodules?.modules?.name}
                                            </button>
                                            <button type="button" className="btn btn-primary btn-digy-dark dropdown-toggle dropdown-toggle-split rounded-end" data-bs-toggle="dropdown" aria-expanded="false"
                                                disabled={!basicPermissionData?.some(x => x?.id === id && x.activities.create === true)}>
                                                <i className="fa fa-caret-down"></i>
                                                <span className="visually-hidden">Toggle Dropdown</span>
                                            </button>
                                            <button type="button" className={`btn px-2 rounded-2 ${showFilter ? 'btn-digy-dark' : 'btn-digy-dark-outline'}`} onClick={() => setShowFilter(!showFilter)}>
                                                <i className="fa fa-filter"></i>
                                            </button>
                                            {(showCharts && formsubmodules?.graphicalStatus) && (
                                                <button type="button" className={`btn px-2 rounded-2 ${open ? 'btn-digy-dark' : 'btn-digy-dark-outline'}`} onClick={() => {
                                                    setOpen(!open);
                                                    localStorage.setItem("isChartOpen", !open);
                                                }} aria-controls="collapseExample">
                                                    <i className="fa fa-pie-chart"></i>
                                                </button>
                                            )}
                                            <ul className="dropdown-menu">
                                                <li><a className="dropdown-item cursor-pointer" onClick={() => setOpenImportModal(true)}><i className="fa fa-file-import me-2"></i> Import</a></li>
                                                <hr className="dropdown-divider" />
                                                <li><a className="dropdown-item cursor-pointer" onClick={clickExportData}><i className="fa-solid fa-file-export me-2"></i> Export</a></li>
                                            </ul>

                                            <button className="nav-link p-0 dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                                <img src={HeaderImages.settingIcon} alt="setting-icon" width="25" height="25" />
                                            </button>
                                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                <li><a className="dropdown-item cursor-pointer" onClick={() => setShowManageColumn(true)}>Manage Column</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    {/* height: showCharts && formsubmodules?.graphicalStatus ? 'calc(100vh - 45vh)' : 'calc(100vh - 17vh)' */}
                                    {columnDefs?.length > 0 && <div className={`ag-theme-quartz ${showCharts && formsubmodules?.graphicalStatus ? 'with-charts' : 'without-charts'}`} style={{ display: "flex", flexDirection: "column", position: "relative" }}>
                                        <AgGridReact
                                            ref={gridRef}
                                            rowData={subFormlayoutList || []}
                                            columnDefs={columnDefs}
                                            defaultColDef={{
                                                filter: showFilter ? 'agTextColumnFilter' : showFilter,
                                                floatingFilter: showFilter,
                                            }}
                                            onCellClicked={(e) => {
                                                let clickedColumn = e.colDef.field;
                                                if (!clickedColumn) return;
                                                setShowPreviewModalIndex(e.rowIndex);
                                            }}                 
                                            rowSelection="multiple"
                                            pagination={false}
                                            rowHeight={40}
                                            floatingFiltersHeight={40}
                                            headerHeight={40}
                                        />
                                        <Pagination
                                            currentPage={currentPage}
                                            pageSize={pageSize}
                                            totalCount={formsubmodules?.totalCount}
                                            onPageSizeChange={handlePageSizeChange}
                                            onPrevPage={handlePrevPage}
                                            onNextPage={handleNextPage}
                                        />
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {openImportModal && <ImportModal show={openImportModal} handleClose={() => setOpenImportModal(false)} moduleId={id} />}
            {removeModalData && <ConfirmationModal data={removeModalData} show={true} handleClose={() => setRemoveModalData(null)} handleSuccess={(subModuleId) => {
                 removeData({ subModuleId: removeModalData.subModuleId, payload: { moduleId: removeModalData.payload.moduleId } });
                setRemoveModalData(null);
            }} />}
            {showManageColumn && <ManageColumn show={showManageColumn} handleClose={() => setShowManageColumn(null)} getValue={dynamicTableHeader} setValue={setDynamicTableHeader} data={{ moduleId: id, tableColumnId: formsubmodules?.tableColumns?._id }} createApi={createTableColumnSubFormModuleStart} updateApi={updateTableColumnSubFormModuleStart} />}
            {showPreviewModalIndex !== null && <PreviewModal show={showPreviewModalIndex !== null} preview={true} moduleStoreData={formsubmodules?.modules?.fields} handleClose={() => 
            {
                setShowPreviewModalIndex(null);
                dispatch(destroyModuleLog());
            }} storeData={formsubmodules?.formsubmodules?.[showPreviewModalIndex] || {}} subFormId={formsubmodules?.formsubmodules?.[showPreviewModalIndex]?._id} moduleId={id}/>}
            {permissionDenied && <PermissionDeniedModal />}
        </>
    );
};

export default SubModule;
